module.exports = __webpack_public_path__ + "static/media/logo_autofact.0e8617d8.svg";